
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, Renderer2 } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { CommonConfirmationModalData } from './common-confirmation-modal.component.model';

@Component({
  selector: 'wm-common-confirmation-modal',
  standalone: false,
  templateUrl: './common-confirmation-modal.component.html',
  styleUrls: ['./common-confirmation-modal.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('{{ inTime }}ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ], { params: { inTime: 300 } }),
      transition(':leave', [
        animate('{{ outTime }}ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ], { params: { outTime: 200 } }),
    ])
  ]
})
export class CommonConfirmationModalComponent implements AfterViewInit, OnDestroy {
  // added by priya 17-03-2026
  constructor(private el: ElementRef, private renderer: Renderer2) {}
  // added by Amisha on 2026-07-13.
  // Reason: Shared confirmation modal appends itself to document.body for overlay stacking,
  // so destroy must remove that detached node instead of re-appending it back into the old
  // parent. Re-attaching stale modal DOM can leave duplicate backdrops/dialogs visible.
  private appendedToBody = false;

  ngAfterViewInit() {
    const modalEl = this.el.nativeElement;
    if (!this.appendedToBody) {
      this.renderer.appendChild(document.body, modalEl);
      this.appendedToBody = true;
    }
  }

  ngOnDestroy() {
    if (this.appendedToBody && this.el.nativeElement.parentElement === document.body) {
      this.renderer.removeChild(document.body, this.el.nativeElement);
    }
    this.appendedToBody = false;
  }
  // end by priya 17-03-2026

  private _data: CommonConfirmationModalData = {
    open: false,
    modalDescp: '',
    modalSubDescp: '',
    yesNoBtn: false,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default',
    customCloseAccepted:false
  };
@Input() isApplicantMobileview:boolean=false

  @Input({ required: true })
  set data(value: CommonConfirmationModalData) {
    this._data = {
      ...this._data,
      ...value,
    };
  }

  get data(): CommonConfirmationModalData {
    return this._data;
  }

  @Output() onYesClick = new EventEmitter<void>();
  @Output() onNoClick = new EventEmitter<void>();
  @Output() onOkClick = new EventEmitter<void>();
  @Output() onCloseClick = new EventEmitter<void>();

  handleBackdropClick(): void {
    //added by amisha on 20-11-2025 to close the modal on clicking outside
    this.data.open = false;
    if (this.data.yesNoBtn) {
      this.onNoClick.emit();
    } else if (this.data.closeBtn) {
      this.onCloseClick.emit();
    } else {
      this.onNoClick.emit();
    }
  }

  handleYesClick(): void {
    this.onYesClick.emit();
    if(this._data.customCloseAccepted)return
    this.data.open = false;
  }

  handleOkClick(): void {
    this.onOkClick.emit();
    this.data.open = false;
  }

  // added by Vipul on 23-06-2026
  handleCloseClick(): void {
    this.data.open = false;
    this.onCloseClick.emit();
  }
  // end by Vipul on 23-06-2026

  getNoButtonData = () => {
    return {
      text: this.data.replaceNoWith || "NO",
      onClick: () => this.handleBackdropClick()
    };
  };

  getYesButtonData = () => {
    return {
      text: this.data.replaceYesWith || "YES",
      onClick: () => this.handleYesClick()
    };
  };

  getCloseButtonData = () => {
    return {
      text: this.data.replaceCloseWith || "CLOSE",
      onClick: () => this.handleCloseClick()
    };
  };

  getOkButtonData = () => {
    return {
      text: this.data.replaceOkWith || "OK",
      onClick: () => this.handleOkClick()
    };
  };

  // added by Vipul rathod on 08-04-2026
  get modalStyles() {
    return {
      '--modal-width': this.data.modalWidth || '412px',
      '--modal-height': this.data.modalHeight || 'auto'
    };
  }
  // added by Vipul rathod on 08-04-2026
}
